// Маппинг кодов флагов к английским названиям стран
export const countryNames = {
    'unknown': 'Unknown Country',
    'my': 'Malaysia',
    'sg': 'Singapore',
    'us': 'United States',
    'gb': 'United Kingdom',
    'ru': 'Russia',
    'de': 'Germany',
    'fr': 'France',
    'cn': 'China',
    'jp': 'Japan',
    'br': 'Brazil',
    'ca': 'Canada',
    'au': 'Australia',
    'in': 'India',
    'th': 'Thailand',
    'id': 'Indonesia',
    'ph': 'Philippines',
    'vn': 'Vietnam',
    'kr': 'South Korea',
    'it': 'Italy',
    'es': 'Spain',
    'nl': 'Netherlands',
    'be': 'Belgium',
    'ch': 'Switzerland',
    'at': 'Austria',
    'se': 'Sweden',
    'no': 'Norway',
    'dk': 'Denmark',
    'fi': 'Finland',
    'pl': 'Poland',
    'cz': 'Czech Republic',
    'hu': 'Hungary',
    'pt': 'Portugal',
    'ie': 'Ireland',
    'gr': 'Greece',
    'tr': 'Turkey',
    'za': 'South Africa',
    'eg': 'Egypt',
    'ma': 'Morocco',
    'ng': 'Nigeria',
    'ke': 'Kenya',
    'mx': 'Mexico',
    'ar': 'Argentina',
    'cl': 'Chile',
    'co': 'Colombia',
    'pe': 'Peru',
    'uy': 'Uruguay',
    'ec': 'Ecuador',
    'bo': 'Bolivia',
    'py': 'Paraguay',
    've': 'Venezuela',
    'nz': 'New Zealand',
    'ad': 'Andorra',
    'ae': 'United Arab Emirates',
    'af': 'Afghanistan',
    'ag': 'Antigua and Barbuda',
    'ai': 'Anguilla',
    'al': 'Albania',
    'am': 'Armenia',
    'ao': 'Angola',
    'aq': 'Antarctica',
    'as': 'American Samoa',
    'aw': 'Aruba',
    'ax': 'Åland Islands',
    'az': 'Azerbaijan',
    'ba': 'Bosnia and Herzegovina',
    'bb': 'Barbados',
    'bd': 'Bangladesh',
    'bf': 'Burkina Faso',
    'bg': 'Bulgaria',
    'bh': 'Bahrain',
    'bi': 'Burundi',
    'bj': 'Benin',
    'bl': 'Saint Barthélemy',
    'bm': 'Bermuda',
    'bn': 'Brunei',
    'bq': 'Caribbean Netherlands',
    'bs': 'Bahamas',
    'bt': 'Bhutan',
    'bv': 'Bouvet Island',
    'bw': 'Botswana',
    'by': 'Belarus',
    'bz': 'Belize',
    'cc': 'Cocos Islands',
    'cd': 'Democratic Republic of the Congo',
    'cf': 'Central African Republic',
    'cg': 'Republic of the Congo',
    'ci': 'Côte d\'Ivoire',
    'ck': 'Cook Islands',
    'cm': 'Cameroon',
    'cr': 'Costa Rica',
    'cu': 'Cuba',
    'cv': 'Cape Verde',
    'cw': 'Curaçao',
    'cx': 'Christmas Island',
    'cy': 'Cyprus',
    'dj': 'Djibouti',
    'dm': 'Dominica',
    'do': 'Dominican Republic',
    'dz': 'Algeria',
    'er': 'Eritrea',
    'et': 'Ethiopia',
    'fj': 'Fiji',
    'fk': 'Falkland Islands',
    'fm': 'Micronesia',
    'fo': 'Faroe Islands',
    'ga': 'Gabon',
    'gd': 'Grenada',
    'ge': 'Georgia',
    'gf': 'French Guiana',
    'gg': 'Guernsey',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gl': 'Greenland',
    'gm': 'Gambia',
    'gn': 'Guinea',
    'gp': 'Guadeloupe',
    'gq': 'Equatorial Guinea',
    'gs': 'South Georgia',
    'gt': 'Guatemala',
    'gu': 'Guam',
    'gw': 'Guinea-Bissau',
    'gy': 'Guyana',
    'hk': 'Hong Kong',
    'hm': 'Heard Island',
    'hn': 'Honduras',
    'hr': 'Croatia',
    'ht': 'Haiti',
    'il': 'Israel',
    'im': 'Isle of Man',
    'io': 'British Indian Ocean Territory',
    'iq': 'Iraq',
    'ir': 'Iran',
    'is': 'Iceland',
    'je': 'Jersey',
    'jm': 'Jamaica',
    'jo': 'Jordan',
    'kh': 'Cambodia',
    'ki': 'Kiribati',
    'km': 'Comoros',
    'kn': 'Saint Kitts and Nevis',
    'kp': 'North Korea',
    'kw': 'Kuwait',
    'ky': 'Cayman Islands',
    'kz': 'Kazakhstan',
    'la': 'Laos',
    'lb': 'Lebanon',
    'lc': 'Saint Lucia',
    'li': 'Liechtenstein',
    'lk': 'Sri Lanka',
    'lr': 'Liberia',
    'ls': 'Lesotho',
    'lt': 'Lithuania',
    'lu': 'Luxembourg',
    'lv': 'Latvia',
    'ly': 'Libya',
    'mc': 'Monaco',
    'md': 'Moldova',
    'me': 'Montenegro',
    'mf': 'Saint Martin',
    'mg': 'Madagascar',
    'mh': 'Marshall Islands',
    'mk': 'North Macedonia',
    'ml': 'Mali',
    'mm': 'Myanmar',
    'mn': 'Mongolia',
    'mo': 'Macao',
    'mp': 'Northern Mariana Islands',
    'mq': 'Martinique',
    'mr': 'Mauritania',
    'ms': 'Montserrat',
    'mt': 'Malta',
    'mu': 'Mauritius',
    'mv': 'Maldives',
    'mw': 'Malawi',
    'mz': 'Mozambique',
    'na': 'Namibia',
    'nc': 'New Caledonia',
    'ne': 'Niger',
    'nf': 'Norfolk Island',
    'ni': 'Nicaragua',
    'np': 'Nepal',
    'nr': 'Nauru',
    'nu': 'Niue',
    'om': 'Oman',
    'pa': 'Panama',
    'pf': 'French Polynesia',
    'pg': 'Papua New Guinea',
    'pk': 'Pakistan',
    'pm': 'Saint Pierre and Miquelon',
    'pn': 'Pitcairn',
    'pr': 'Puerto Rico',
    'ps': 'Palestine',
    'pw': 'Palau',
    'qa': 'Qatar',
    're': 'Réunion',
    'ro': 'Romania',
    'rs': 'Serbia',
    'rw': 'Rwanda',
    'sa': 'Saudi Arabia',
    'sb': 'Solomon Islands',
    'sc': 'Seychelles',
    'sd': 'Sudan',
    'sh': 'Saint Helena',
    'si': 'Slovenia',
    'sj': 'Svalbard and Jan Mayen',
    'sk': 'Slovakia',
    'sl': 'Sierra Leone',
    'sm': 'San Marino',
    'sn': 'Senegal',
    'so': 'Somalia',
    'sr': 'Suriname',
    'ss': 'South Sudan',
    'st': 'São Tomé and Príncipe',
    'sv': 'El Salvador',
    'sx': 'Sint Maarten',
    'sy': 'Syria',
    'sz': 'Eswatini',
    'tc': 'Turks and Caicos Islands',
    'td': 'Chad',
    'tf': 'French Southern Territories',
    'tg': 'Togo',
    'tj': 'Tajikistan',
    'tk': 'Tokelau',
    'tl': 'East Timor',
    'tm': 'Turkmenistan',
    'tn': 'Tunisia',
    'to': 'Tonga',
    'tt': 'Trinidad and Tobago',
    'tv': 'Tuvalu',
    'tw': 'Taiwan',
    'tz': 'Tanzania',
    'ua': 'Ukraine',
    'ug': 'Uganda',
    'um': 'United States Minor Outlying Islands',
    'vc': 'Saint Vincent and the Grenadines',
    'vg': 'British Virgin Islands',
    'vi': 'U.S. Virgin Islands',
    'vu': 'Vanuatu',
    'wf': 'Wallis and Futuna',
    'ws': 'Samoa',
    'ye': 'Yemen',
    'yt': 'Mayotte',
    'zm': 'Zambia',
    'zw': 'Zimbabwe',
    'eu': 'European Union',
    'un': 'United Nations',
    'arab': 'Arab League',
    'asean': 'ASEAN',
    'gb-eng': 'England',
    'gb-sct': 'Scotland',
    'gb-wls': 'Wales',
    'gb-nir': 'Northern Ireland',
    'es-ct': 'Catalonia',
    'es-ga': 'Galicia',
    'es-pv': 'Basque Country'
};

// Функция для получения английского названия страны по коду флага
export const getCountryNameByFlag = (flagCode) => {
    if (!flagCode || flagCode === 'unknown') {
        return 'Unknown Country';
    }
    return countryNames[flagCode] || 'Unknown Country';
};

